import { fetchGet } from '../helperApi'

export const fetchCustomersApi = (companyId, params) => {
    return fetchGet(`company/${companyId}/customers`, params)
}

export const fetchCustomersLiveSearchApi = params => {
    return fetchGet(`inspections/filters/live/customers`, params)
}
